import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
export default class AchievementAwardedNotification extends Notification {
  icon() {
    return 'fas fa-trophy';
  }
  href() {
    return app.route('userAchievements', {
      username: app.session.user.username()
    });
  }
  content() {
    const count = this.attrs.notification.content().count;
    if (count > 1) {
      return app.translator.trans('nagusi-achievements.forum.notification.achievements_awarded', {
        count
      });
    }
    return app.translator.trans('nagusi-achievements.forum.notification.achievement_awarded');
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/achievements/AchievementAwardedNotification', AchievementAwardedNotification);